export const META_FACEBOOK_APP_ID = {
  VPAGE_PROD: '289777744796993',
  VPAGE_DEV: '1734134636613442',
} as const;
